var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Facebook_svg__a",
    x1: 0.925,
    x2: 0.051,
    y1: 0.956,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb100"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18439",
    transform: "translate(-1133.5 -6957)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    "data-name": "Rectangle 95",
    rx: 7,
    style: {
      fill: "url(#Facebook_svg__a)"
    },
    transform: "translate(1133.5 6957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.357 18V9.79h2.755l.413-3.2h-3.168V4.546c0-.926.256-1.558 1.586-1.558h1.693V.125A22.961 22.961 0 0 0 44.169 0a3.856 3.856 0 0 0-4.116 4.229v2.36H37.29v3.2h2.763V18z",
    style: {
      fill: "#fff"
    },
    transform: "translate(1109.537 6966)"
  })));
};
export default SvgFacebook;